import PanelList from './PanelList';

export default PanelList;
